<template>
    <div>
        <div class="table--header">
            <div></div>
            <div>
                <a-form layout="inline">
                    <a-form-item>
                        <a-range-picker @change="dateChanged" :allowClear="true"/>
                    </a-form-item>
                    <a-form-item>
                        <ListFilter :filters="filters" @filterChanged="filterChanged"></ListFilter>
                    </a-form-item>
                    <a-form-item>
                        <a-input v-model="searchKey" placeholder="Search" @keyup.enter="keyChanged"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-button @click.prevent="keyChanged" style="margin-left: 8px;">Search</a-button>
                    </a-form-item>
                </a-form>
            </div>
        </div>
        <a-table
                :style="{background:'#fff'}"
                :columns="columns"
                :loading="loading"
                :pagination="false"
                :dataSource="all_campaigns.data"
                :rowKey="data => data.id"
                :bordered="false"
                @change="handleTableChange"
        >
            <router-link
                    slot="name"
                    slot-scope="text, rowData"
                    :to="{ name: 'sites.campaign.overview', params: { siteId: rowData.site_id, campaignId: rowData.id }}"
            >
                {{text}}
            </router-link>
            <span slot="site" slot-scope="text, rowData">
            {{text}}
              &nbsp;
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ rowData.site_url }}</span>
              </template>
              <a  :href="rowData.site_url" target="_blank">
                <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
              </a>
            </a-tooltip>
        </span>

        </a-table>
        <div class="pagination" v-if="all_campaigns && all_campaigns.meta">
            <span>total {{ all_campaigns.meta.total }} items</span>
            <span style="margin-left: 15px; margin-right: 15px; color: #cecece;">|</span>
            <span>page {{ all_campaigns.meta.current_page }} of {{ all_campaigns.meta.last_page }}</span>
            <span style="margin-left: 15px; margin-right: 15px; color: #cecece;" v-if="all_campaigns.meta.last_page > 1">|</span>
            <a :disabled="all_campaigns.meta.current_page == 1"
               style="margin-right: 10px;"
               class="pagination--btn"
               @click.prevent="paginate(all_campaigns.meta.current_page - 1)"
               v-if="all_campaigns.meta.last_page > 1"
            >&lt; Previous</a>
            <a
                    :disabled="all_campaigns.meta.current_page == all_campaigns.meta.last_page"
                    class="pagination--btn"
                    @click.prevent="paginate(all_campaigns.meta.current_page + 1)"
                    v-if="all_campaigns.meta.last_page > 1"
            >Next &gt;</a>
        </div>
    </div>
</template>
<script>

  import { mapGetters, mapActions } from "vuex";
  import ListFilter from "@/components/ListFilter.vue";

  const sendingListColumns = [
    {
      title: "Campaign",
      dataIndex: "name",
      sorter: () => {},
      key: "name",
      scopedSlots: { customRender: "name" }
    },
    {
      title: "Site",
      dataIndex: "site",
      key: "site",
      scopedSlots: { customRender: "site" }
    },
    {
      title: "Subscribers",
      dataIndex: "subscribers_count",
      sorter: () => {},
      key: "subscribers_count",
      scopedSlots: { customRender: "subscribers_count" }
    },
    {
      title: "Sent",
      dataIndex: "sent",
      sorter: () => {},
      key: "sent",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status"
    },
    {
      title: "Schedule at",
      dataIndex: "deliver_at",
      sorter: () => {},
      key: "deliver_at",
      scopedSlots: { customRender: "deliver_at" }
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      sorter: () => {},
      key: "created_at"
    }
  ];
  const scheduledListColumns = [
    {
      title: "Campaign",
      dataIndex: "name",
      sorter: () => {},
      key: "name",
      scopedSlots: { customRender: "name" }
    },
    {
      title: "Site",
      dataIndex: "site",
      key: "site",
      scopedSlots: { customRender: "site" }
    },
    {
      title: "Subscribers",
      dataIndex: "subscribers_count",
      sorter: () => {},
      key: "subscribers_count"
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Schedule Time",
      dataIndex: "deliver_at",
      sorter: () => {},
      key: "deliver_at",
      scopedSlots: { customRender: "deliver_at" }
    },
    {
      title: "Deliver Timezone",
      dataIndex: "deliver_timezone",
      sorter: () => {},
      key: "deliver_timezone",
      scopedSlots: { customRender: "deliver_timezone" }
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status"
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      sorter: () => {},
      key: "created_at"
    }
  ];

  export default {
    props: ['type'],
    components: {
      ListFilter
    },
    data() {
      return {
        columns: [],
        searchKey: '',
        searchQuery: {
          page: null,
          s: '',
          start_date: '',
          end_date: '',
          orderBy: '',
          order: '',
          type: '',
          status: this.type
        },
        filters: [
          {
            id: 'type',
            category: 'Type',
            type: 'radio',
            inputs: [
              {value: 'standard', label: 'Standard'},
              {value: 'automatic', label: 'Automatic'}
            ]
          }
        ],
        loading: false
      };
    },
    computed: {
      ...mapGetters({
        all_campaigns: "campaigns/all_campaigns"
      })
    },
    methods: {
      handleTableChange(pagination, filters, sorter) {
        if (sorter.field && sorter.order) {
          this.searchQuery.orderBy = sorter.field;
          this.searchQuery.order = sorter.order;

          this.urlUpdate();
          this.search();
        }
      },

      ...mapActions({
        getCampaigns: "campaigns/GET_ALL_CAMPAIGNS"
      }),


      paginate(page) {
        this.searchQuery.page = page;

        this.urlUpdate();
        this.search();
      },

      dateChanged(date, dateString) {
        this.searchQuery.start_date = dateString[0];
        this.searchQuery.end_date = dateString[1];

        this.urlUpdate();
        this.search();
      },

      filterChanged(data) {
        switch (data.category) {
          case 'status' :
            this.searchQuery.status = data.value;
            break;
          case 'type' :
            this.searchQuery.type = data.value;
            break;
          default:
            this.resetQuery();
        }
        this.urlUpdate();

        this.search();
      },

      search() {
        this.loading = true;
        if (! this.searchQuery) return;
        this.$store.commit("campaigns/GET_ALL_CAMPAIGNS", { query: this.searchQuery , context: this});
      },

      urlUpdate() {
        let route = {
          name: this.$route.name,
          query: {}
        };

        if (this.searchQuery.status) {
          route.query.status = this.searchQuery.status;
        }
        if (this.searchQuery.status) {
          route.query.type = this.searchQuery.type;
        }
        if (this.searchQuery.page) {
          route.query.page = this.searchQuery.page;
        }
        if (this.searchQuery.orderBy) {
          route.query.orderBy = this.searchQuery.orderBy;
        }
        if (this.searchQuery.order) {
          route.query.order = this.searchQuery.order;
        }

        this.$router.push(route);
      },


      keyChanged () {
        this.resetQuery();
        this.searchQuery.s = this.searchKey;
        this.search();
      },

      resetQuery() {
        this.searchKey = '';

        this.searchQuery = {
          page: 1,
          s: '',
          orderBy: '',
          order: '',
          start_date: '',
          end_date: '',
          type: '',
          status: this.type
        };

        this.urlUpdate();
      },

      handleFilterSelection() {
        let vm = this;
        const queryParams = vm.$router.currentRoute.query;

        if (queryParams.page) {
          vm.searchQuery.page = queryParams.page;
        }
        if (queryParams.s) {
          vm.searchQuery.s = queryParams.s;
        }
        if (queryParams.type) {
          const type = queryParams.type;
          if (typeof type === 'string') {
            vm.searchQuery.type = type;
          }
        }
        if (queryParams.status) {
          const status = queryParams.status;
          if (typeof status === 'string') {
            vm.searchQuery.status = [status];
          } else {
            vm.searchQuery.status = status;
          }
        }
        if (queryParams.orderBy) {
          const orderBy = queryParams.orderBy;
          if (typeof orderBy === 'string') {
            vm.searchQuery.orderBy = orderBy;
          }
        }
        if (queryParams.order) {
          const order = queryParams.order;
          if (typeof order === 'string') {
            vm.searchQuery.order = order;
          }
        }

        this.search();
      },
    },
    created() {
      this.handleFilterSelection();

      if (this.type === 'active') {
        this.columns = sendingListColumns;
      } else if (this.type === 'scheduled') {
        this.columns = scheduledListColumns;
      }
    }
  };
</script>
<style scoped lang="scss">
    .pagination {
        font-weight: normal;
        float: right;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .pagination--btn {
        background-color: #e5e5e5;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 5px 9px;
        line-height: 1.8;
    }
    .search {
        padding: 4px 5px 5px;
        margin: 0;
        line-height: 1.3;
        border: 1px solid #e1e1e1;
        border-radius: 5px;
    }
    .search--btn {
        text-decoration: none;
        font-size: 13px;
        line-height: 26px;
        height: 28px;
        margin: 0;
        padding: 0 10px 1px;
        cursor: pointer;
        border-width: 1px;
        border-style: solid;
        -webkit-appearance: none;
        border-radius: 3px;
        white-space: nowrap;
        box-sizing: border-box;
    }
    .table--header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
</style>
